module.exports = __webpack_public_path__ + "img/it_seguroportatil.d69e8188.png";